module.exports = __webpack_public_path__ + "static/media/success.cd291b35.svg";